import CheckRoundedIcon from "@mui/icons-material/CheckRounded.js";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded.js";
import { Popover, List, ListSubheader, ListItemIcon, css, Typography, Link, IconButton, Button, ListItemButton, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import "react/jsx-runtime";
import { MessageBubbleIcon } from "../../../../../components/icons/MessageBubble/MessageBubble.js";
import { TabletIcon } from "../../../../../components/icons/TabletIcon/TabletIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
const StyledPopover = styled(Popover)(({ theme }) => ({
  marginTop: theme.spacing(1),
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "10px",
  "& .MuiPopover-paper": {
    minWidth: "290px"
  }
}));
const StyledPopoverContent = styled("div")`
  padding: ${({ theme }) => theme.spacing(2)};
`;
const StyledList = styled(List)`
  padding-bottom: 0;

  &:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }
`;
const StyledListSubheader = styled(ListSubheader)(({ theme }) => ({
  fontFamily: "'Lato'",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: theme.palette.grey[800]
}));
const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 16px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;
const StatusDoneIcon = styled(CheckRoundedIcon)(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.success[500]
}));
const StatusNotDoneIcon = styled(CloseRoundedIcon)`
  font-size: 24px;
  color: #ff647c;
`;
const ListItemContentWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "isHidden"
})`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  ${({ isHidden }) => isHidden && css`
      visibility: hidden;
    `}
`;
const ListItemTextWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledListItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const StyledLink = styled(Link)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 700,
  fontFamily: "'Lato'",
  color: theme.palette.primary[800],
  cursor: "pointer",
  textDecoration: "underline",
  "&:hover": {
    textDecoration: "none"
  }
}));
const Time = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.grey[800]
}));
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: "24px",
  height: "24px",
  color: theme.palette.primary[800]
}));
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "contained"
})(({ theme, contained }) => ({
  fontSize: "12px",
  letterSpacing: "0.5px",
  lineHeight: "24px",
  padding: theme.spacing(0.5, 2),
  color: theme.palette.primary[800],
  textTransform: "none",
  ...contained && {
    backgroundColor: theme.palette.primary[800],
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.primary[900]
    }
  },
  "&:not(:last-child)": {
    marginRight: theme.spacing(0.5)
  }
}));
const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "isClickable"
})`
  height: 16px;
  border: 0;
  margin-top: ${({ theme }) => theme.spacing(2)};
  cursor: ${({ isClickable }) => isClickable ? "pointer" : "default"};

  &:hover {
    background-color: transparent;
  }

  &:not(:last-child) {
    padding-bottom: ${({ theme }) => theme.spacing(1.5)} !important;
  }
`;
const ListItemButtonText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "disabled"
})(({ theme, disabled }) => ({
  color: theme.palette.primary[800],
  ...disabled && {
    color: theme.palette.grey[800],
    "& .MuiSvgIcon-root": {
      color: theme.palette.grey[800]
    }
  }
}));
const StyledMessageBubbleIcon = styled(MessageBubbleIcon, { name: "StyledMessageBubbleIcon" })(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.primary[800],
  marginRight: theme.spacing(1.5)
}));
const SmsSentIcon = styled(CheckRoundedIcon)(({ theme }) => ({
  fontSize: "20px",
  color: theme.palette.success[500],
  marginRight: theme.spacing(0.5)
}));
const SmsSentText = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.success[500]
}));
const SendSmsAgainButton = styled(Button)(({ theme }) => ({
  fontFamily: "'Lato'",
  fontSize: "14px",
  fontWeight: 400,
  letterSpacing: "0.25px",
  lineHeight: "20px",
  textTransform: "none",
  marginLeft: theme.spacing(1),
  padding: 0,
  color: theme.palette.grey[800],
  ".MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: theme.spacing(0.5)
  },
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.primary[800],
    textDecoration: "underline",
    ".MuiButton-startIcon": {
      color: theme.palette.primary[800]
    }
  }
}));
const StyledTabletIcon = styled(TabletIcon, { name: "StyledTabletIcon" })(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.primary[800],
  marginLeft: theme.spacing(0.5),
  marginRight: theme.spacing(1)
}));
const GeneratedCodeListItem = styled(ListItem)(({ theme }) => ({
  height: "16px",
  marginTop: theme.spacing(2)
}));
const GeneratedCodeText = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.primary[800]
}));
export {
  GeneratedCodeListItem,
  GeneratedCodeText,
  ListItemButtonText,
  ListItemContentWrapper,
  ListItemTextWrapper,
  SendSmsAgainButton,
  SmsSentIcon,
  SmsSentText,
  StatusDoneIcon,
  StatusNotDoneIcon,
  StyledButton,
  StyledIconButton,
  StyledLink,
  StyledList,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  StyledListSubheader,
  StyledMessageBubbleIcon,
  StyledPopover,
  StyledPopoverContent,
  StyledTabletIcon,
  Time
};
